import "./js/mobile-menu";
import "./js/collapsible-menu";
import "./js/header-menu";
import "./js/header-shadow-after-scroll";
import "./js/language-toggler";
import "./js/tabs-handler";
import "./js/language-toggler";
import "./js/href-swap";
